var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 38
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.0244141H39.3921V37.9605H0V0.0244141Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3769 17.9174C4.3769 21.1614 4.68482 23.0872 5.30065 23.6947C8.25162 28.2977 10.2704 31.1498 11.3535 32.2499C13.8864 33.8282 16.8637 34.6167 20.2843 34.6167H20.6845C25.4902 34.6167 29.5182 31.7526 32.7699 26.022C34.2676 22.2363 35.0152 19.4201 35.0152 17.5758C35.0152 16.0695 34.6186 14.1497 33.8267 11.814C33.0012 8.91757 31.6868 6.78206 29.8825 5.41472C27.3748 3.49013 24.5724 2.52783 21.4741 2.52783C16.5558 2.52783 11.7789 4.85028 7.14455 9.49518C5.30065 11.9219 4.3769 14.5523 4.3769 17.3829V17.9174ZM0 15.1417C0 12.0154 1.01766 9.7157 3.05172 8.24245C8.23683 2.76334 13.8066 0.0244141 19.7585 0.0244141H21.0984C26.3968 0.0244141 30.87 1.63436 34.5178 4.85297C35.8156 6.41355 36.8295 8.145 37.558 10.0486C38.7807 13.1482 39.3921 15.7226 39.3921 17.7755C39.3921 20.3803 38.2547 24.1887 35.9799 29.2046C33.0008 33.4383 29.9911 36.0747 26.9522 37.1062C25.4594 37.6758 23.6686 37.9605 21.5824 37.9605H20.9735C17.3792 37.9605 13.6792 37.0239 9.8735 35.1571C7.5707 34.0888 5.57995 31.6929 3.90762 27.9604C1.46854 24.8064 0.248366 22.5699 0.248366 21.2498V20.2854C0.248366 19.5412 0.165577 17.8262 0 15.1417V15.1417Z",
    fill: "#F03B38"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6967 20.7167C17.3958 20.7167 16.1727 18.453 16.1727 16.278C16.1727 13.995 18.6642 12.3735 20.8563 12.3735C23.1572 12.3735 24.7822 14.103 24.7822 16.278C24.7822 18.453 23.047 20.7167 20.8563 20.7167H19.6967ZM11.084 15.0532C11.084 19.3326 17.0324 27.4065 18.3845 28.7639C18.6958 29.0773 19.6967 29.9594 20.7185 30.1921C21.4365 30.4349 21.8921 29.9594 21.9359 29.9131C23.4917 28.2688 28.7851 23.08 28.7851 14.1894C28.6818 9.49164 24.8165 7.24561 20.7185 7.24561C15.9303 7.24561 11.084 10.2518 11.084 15.0532Z",
    fill: "#F03B38"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLocation);
export default __webpack_public_path__ + "static/media/footer-location.750ed61795c71e29154dd145b7d62467.svg";
export { ForwardRef as ReactComponent };